<template>
  <div id="app">
    <TheHeader />
    <main>
      <router-view />
    </main>
    <TheFooter />
    <FloatingSidebar />
  </div>
</template>

<script>
import TheHeader from './components/TheHeader.vue'
import TheFooter from './components/TheFooter.vue'
import FloatingSidebar from './components/FloatingSidebar.vue'
import { getRouteSeo, buildMetaInfo, buildStructuredData } from './utils/seo'

export default {
  name: 'App',
  components: {
    TheHeader,
    TheFooter,
    FloatingSidebar
  },
  metaInfo() {
    const seo = getRouteSeo(this.$route)
    return {
      ...buildMetaInfo(seo),
      script: buildStructuredData(this.$route, seo)
    }
  },
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
}
</script>

<style>
#app {
  min-height: 100vh;
}
</style>
